import React from "react";
import { Image as ImageIcon, Trash2 } from "lucide-react";

interface ImageLinkModalProps {
  isOpen: boolean;
  imageLinkUrl: string;
  imageLinkTarget: "_blank" | "_self";
  hasExistingLink: boolean;
  onImageLinkUrlChange: (value: string) => void;
  onImageLinkTargetChange: (value: "_blank" | "_self") => void;
  onSubmit: () => void;
  onRemove: () => void;
  onClose: () => void;
}

export const ImageLinkModal: React.FC<ImageLinkModalProps> = ({
  isOpen,
  imageLinkUrl,
  imageLinkTarget,
  hasExistingLink,
  onImageLinkUrlChange,
  onImageLinkTargetChange,
  onSubmit,
  onRemove,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
          <ImageIcon className="w-5 h-5" />
          Add Link to Image
        </h3>
        <div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Link URL</label>
            <input
              type="url"
              value={imageLinkUrl}
              onChange={(e) => onImageLinkUrlChange(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && onSubmit()}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-main/20 focus:border-primary-main"
              placeholder="https://example.com"
              autoFocus
            />
            <p className="text-xs text-gray-500 mt-1">
              When users click on this image, they will be taken to this URL.
            </p>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Open Link In</label>
            <select
              value={imageLinkTarget}
              onChange={(e) => onImageLinkTargetChange(e.target.value as "_blank" | "_self")}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-main/20 focus:border-primary-main"
            >
              <option value="_blank">New Tab</option>
              <option value="_self">Same Tab</option>
            </select>
          </div>
          <div className="flex gap-2 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50 transition-all"
            >
              Cancel
            </button>
            {imageLinkUrl && (
              <button
                type="button"
                onClick={onRemove}
                className="px-4 py-2 border border-red-300 text-red-600 rounded-md text-sm font-medium hover:bg-red-50 transition-all"
              >
                Remove Link
              </button>
            )}
            <button
              type="button"
              onClick={onSubmit}
              disabled={!imageLinkUrl}
              className="px-4 py-2 bg-primary-main text-white rounded-md text-sm font-medium hover:bg-primary-main/90 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {hasExistingLink ? "Update Link" : "Add Link"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


